function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.67572e-06 0.759481C1.46194 14.356 9.80935 12.1408 10.5619 11.4019C9.17698 8.03605 7.93637 6.28644 4.80086 3.44003C9.40966 5.12025 11.6828 11.7261 11.5 11.0761C12.7448 -2.07104 1.95789 -0.378251 6.67572e-06 0.759481Z",
  fill: "#45AA82"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23 0.759431C21.5381 14.3559 13.1906 12.1407 12.4381 11.4018C13.823 8.03596 15.0636 6.28636 18.1991 3.43997C13.5903 5.12017 11.3172 11.726 11.5 11.0761C10.2552 -2.07105 21.0421 -0.378295 23 0.759431Z",
  fill: "#45AA82"
});

function SvgVegan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 12,
    viewBox: "0 0 23 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegan);
export default __webpack_public_path__ + "static/media/Vegan.3aca056a.svg";
export { ForwardRef as ReactComponent };